import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { FilterAttributeOptionComponentDef } from '@df/catalog-ui/listing/filter/filter-attribute-option.component.def';
import { Model } from '@df/catalog/model';

@Component({
    selector: 'filters',
    templateUrl: './filters.html',
    styleUrls: ['./filters.scss']
})
export class FiltersComponent<T extends Model> extends FilterAttributeOptionComponentDef<T> {
    private changeDetectorRef = inject(ChangeDetectorRef);
    toggleState = false;

    override canAsync = false;

    protected toggle(): void {
        this.toggleState = !this.toggleState;
        this.changeDetectorRef.detectChanges();
    }
}
